module.exports = __webpack_public_path__ + "img/8.58a7b6e5.jpg";